import React from 'react';
import ReactDOM from 'react-dom';
import 'src/shared/a11y/reactAxe';
import {Provider} from 'react-redux';
import 'src/styles/base.scss';

import {App} from 'src/pages/reportIssue/App';
import {store} from 'src/pages/reportIssue/store/';
import {start} from 'src/pages/reportIssue/store/actions/start';

store.dispatch(start());

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
);

window.XHS = window.XHS || {};
window.XHS.store = store;
